import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';

import { catchError, Observable, throwError, timeout } from 'rxjs';
import { ConfigService } from './config.service';
import { AlertService } from '../pages/shared/alert/alert.service';
import { Router } from '@angular/router';
import { SnackbarService } from './snackbar.service';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class Interceptor implements HttpInterceptor {
  constructor(
    public config: ConfigService,
    public alert: AlertService,
    private snackbarService: SnackbarService,
    private router: Router
  ) {}
  // intercept(req: HttpRequest<any>, next: HttpHandler):
  //   Observable<HttpEvent<any>> {
  //   return next.handle(req);
  // }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    // Get the auth token from the service.
    // let access_token = localStorage.getItem("access_token");
    // const authToken = localStorage.getItem('access_token');
    this.config.token = localStorage.getItem('access_token');
    const authToken = this.config.token
      ? this.config.token
      : 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC8xODQuNzIuMTQyLjE0M1wvYXV0aF9zZXJ2aWNlXC9hcGlcL2F1dGhcL2xvZ2luIiwiaWF0IjoxNjU1MjExNzAyLCJleHAiOjE2NTUyMTUzMDIsIm5iZiI6MTY1NTIxMTcwMiwianRpIjoiNVhUd1BzWVZrc0NHa2NXNyIsInN1YiI6MSwicHJ2IjoiMjNiZDVjODk0OWY2MDBhZGIzOWU3MDFjNDAwODcyZGI3YTU5NzZmNyIsImVtYWlsIjoiY2xpZW50QHNodGlrcy5jb20iLCJjbGllbnQiOjEsInNlcnZpY2VfcHJvdmlkZXIiOm51bGx9.5kE-nFB77VrtzkPaBtJkQyN8Bt9UCHlnc6_Tk5Ncots';
    // const authToken = this.config.token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC8xODQuNzIuMTQyLjE0M1wvYXV0aF9zZXJ2aWNlXC9hcGlcL2F1dGhcL2xvZ2luIiwiaWF0IjoxNjU0MDk3MzMzLCJleHAiOjE2NTQxMDA5MzMsIm5iZiI6MTY1NDA5NzMzMywianRpIjoiYXA4N1VOVmhlaG1rbjNUYiIsInN1YiI6MSwicHJ2IjoiMjNiZDVjODk0OWY2MDBhZGIzOWU3MDFjNDAwODcyZGI3YTU5NzZmNyIsImVtYWlsIjoiY2xpZW50QHNodGlrcy5jb20iLCJjbGllbnQiOjEsInNlcnZpY2VfcHJvdmlkZXIiOm51bGx9.xn0HOyFnYztkq0l0ZDnCYrYWVb6ieP-wOappwEwLulk';

    const authReq = req.clone({
      headers: req.headers.set('access_token', authToken),
    });

    // send cloned request with header to the next handler.
    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (
          error.status === 504 ||
          error.status === 408 ||
          error.status === 0
        ) {
          setTimeout(() => {
            this.alert.show('Network Error', 'error');
          }, 500);
        }
        if (error.status === 401) {
          this.handleUnauthorized(error);
        }
        return throwError(error);
      })
    );
  }

  handleUnauthorized(error: HttpErrorResponse) {
    const rememberMe = localStorage.getItem('rememberMe');
    if (rememberMe !== 'true') {
      localStorage.clear();
    }
    //Generic error message for unauthorized and not using error message from backend
    const errorMessage = 'Unauthorized';
    this.snackbarService.openSnackBar(errorMessage, 'close', 2000);
    this.router.navigate(['login']);
  }
}
